import React from 'react';
import { Mail } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { href: '#inicio', label: 'Início' },
    { href: '#servicos', label: 'Serviços' },
    { href: '#projetos', label: 'Projetos' },
    { href: '#sobre', label: 'Sobre' },
    { href: '#contato', label: 'Contato' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="text-2xl font-bold tracking-tight mb-4">
              <span className="text-white">Es</span>
              <span className="text-cyan-400">Soluções</span>
              <span className="text-white/80 font-light">Tec</span>
            </div>
            <p className="text-white/50 leading-relaxed max-w-md mb-6">
              Transformando ideias em soluções digitais. Especialistas em desenvolvimento de software e sistemas ERP para empresas de todos os portes.
            </p>
            <div className="flex gap-3">
              <a
                href={`mailto:${companyInfo.email}`}
                className="w-10 h-10 flex items-center justify-center bg-white/5 border border-white/10 hover:bg-cyan-400 hover:border-cyan-400 transition-all duration-300 group"
              >
                <Mail className="w-5 h-5 text-white/60 group-hover:text-black" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold mb-6">Navegação</h4>
            <nav className="space-y-3">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="block text-white/50 hover:text-cyan-400 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contato</h4>
            <div className="space-y-4">
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-3 text-white/50 hover:text-cyan-400 transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span className="text-sm">{companyInfo.email}</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10 flex items-center justify-center">
          <p className="text-white/40 text-sm">
            © {currentYear} Es Soluções Tec. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
